import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
@Component({
  selector: 'app-discussion-development-brands',
  templateUrl: './discussion-development-brands.component.html',
  styleUrls: ['./discussion-development-brands.component.scss']
})
export class DiscussionDevelopmentBrands implements OnInit {

  @Input() dataReport: any
  title_report = 'DIỄN BIẾN THẢO LUẬN VỀ CÁC THƯƠNG HIỆU';
  contentTop = ``;
  public lineChartData = [
    { data: [65, 59, 80, 81, 56, 55, 40], label: 'Series A' },
  ];
  public lineChartLabels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
  public lineChartOptions = {
    responsive: true,
  };

  public lineChartColors = [
    // {
    //   // borderColor: '#f3802f',
   
    //   backgroundColor: 'rgba(173, 219, 219)'
    // },
    // {
    //   // borderColor: 'black',
    //   backgroundColor: 'rgba(0,0,0,0.3)'
  
    // },
    // {
    //   // borderColor: 'black',
      
    //   backgroundColor: 'rgba(255,0,0,0.3)'

    // },
    // {
    //   // borderColor: 'black',
  
    //   backgroundColor: 'rgba(134, 139, 232)'
    // }
  ];
  public lineChartLegend = true;
  public lineChartType = 'line';
  public lineChartPlugins = [];

  constructor() {
  }

  ngOnInit(): void {
  };
  ngOnChanges(changes: SimpleChanges) {
    this.mappingData()
    // changes.prop contains the old and the new value...
  }
  mappingData() {
    if(this.dataReport && this.dataReport.data) {
      if(this.dataReport.report_title) {
        this.title_report = this.dataReport.report_title;
      }
      this.lineChartLabels = this.dataReport.data.lineChartLabels;
      this.lineChartData = this.dataReport.data.lineChartData;
      if(this.dataReport.data.contentTop) {
        this.contentTop = this.dataReport.data.contentTop;
      }
    }
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-component/discussion-development-brands/discussion-development-brands.component.ts